import TodayMealCard from "./TodayMealCard";
import TodayFoodCard from "./TodayFoodCard";

function getLocalDateString() {
  return new Date().toLocaleDateString('en-CA', {
    timeZone: 'Europe/Berlin'
  }); // "2026-06-24"
}

export default function TodayEntriesList({
  entries,
  meals,
  foodsById,
  foods,
  onAddFood
}) {

  const today = getLocalDateString();

  // const sortedEntries = [...entries].reverse();

    const sortedEntries = [...entries]
    .filter(entry => {
      const entryDate = new Date(entry.time).toLocaleDateString('en-CA', {
        timeZone: 'Europe/Berlin'
      });
      return entryDate === today;
    })
    .reverse();

  return (
    <>

      {sortedEntries.map((entry) => {

        if (entry.type === "meal") {
          return (
            <TodayMealCard
              key={entry.id}
              entry={entry}
              meals={meals}
              foodsById={foodsById}
              foods={foods}
              onAddFood={onAddFood}
            />
          );
        }

        if (entry.type === "food") {
          return (
            <TodayFoodCard
              key={entry.id}
              entry={entry}
              foodsById={foodsById}
            />
          );
        }

        return null;
      })}
    </>
  );
}